<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <form v-if="drug && drug.id" action="" @submit.prevent="saveDrug">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Название на платформе</label>
                <input required class="form-control" type="text" v-model="drug.title"/>
              </div>
              <div class="form-group">
                <label for="">Название на английском</label>
                <input class="form-control" type="text" v-model="drug.en_title"/>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Морион</label>
                <input disabled class="form-control" type="text" v-model="drug.id"/>
              </div>
              <div class="form-group">
                <label for="">Действующее вещество</label>
                <input class="form-control" type="text" v-model="drug.substance"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Данные для страны (поставщиков)</label>
                <TitleForSuppliers
                  ref="suppliersTitles"
                  :records="allDetails"
                />
              </div>

              <SelectCombineDrugs
                class="mt-1"
                ref="combineDrugs"
                :selectedCombinedList="drug.combined_drugs"
                :selectedCombineType="drug.combined_type"
              />
            </div>
            <div class="col-md-6">
              <div class="flex flex_gap_5 align-items-center">
                <label>Габариты препарата</label>
                <button type="button" v-if="!editDrugDimensions" @click="editDrugDimensions = true"
                        class="btn btn-default btn-xs">
                  редактировать
                </button>
                <v-popover
                  placement="bottom"
                  :auto-hide="true"
                >
                  <button type="button" class="btn btn-outline-info btn-xs">Отправить на замер</button>
                  <template slot="popover">
                    <div class="mt-1">
                      <div class="form-group">
                        <label>Страна препарата</label>
                        <select v-model="newDimension.countryId" class="form-control">
                          <option value="0">Страна по факту замера</option>
                          <option v-for="c in $AllCountries" :value="c.id">{{ c.name }}</option>
                        </select>
                      </div>
                    </div>
                    <LoadingButton
                      title="Отправить"
                      :loading="btnLoading"
                      type="button"
                      :color="$constants.LOADING_COLOR"
                      :onClick="() => getDimensionTask(drug.id)"
                      className="btn btn-outline-info btn-xs mt-1"
                    />
                  </template>
                </v-popover>
              </div>
              <CountryDimension ref="countryDimensions" :disableToEdit="!editDrugDimensions"
                                :drugId="drug.id"
                                :records="allDetails"/>
            </div>
          </div>

        </div>
      </div>

      <div class="card" v-if="access.projectPrices">
        <div class="card-body">
          <TasksProjectCreate
            :drugId="drug.id"
            :prices="drug.prices"
            :tasks="drug.tasks"
          />
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-9">
              <Recipe :detail="details.recipe"/>
            </div>
            <div class="col-md-3 pt-4">
              <label for="ch11">Регулярный прием (кол. дней)</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <input id="ch11" type="checkbox" v-model="details.regular_reception.use.value">
                  </div>
                </div>
                <input v-model="details.regular_reception.days.value" type="number" class="form-control">
              </div>
              <div class="form-group">
                <label for="">Фасовка</label>
                <input class="form-control" type="number" v-model="drug.packaging"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow-sm">
        <div class="card-body">
          <EgkSelect ref="egkCodes"
                     :details="Object.values(details.egk)"
                     :updateDetail="(d) => this.details.egk = d"/>
        </div>
      </div>

      <div class="card shadow-sm">
        <div class="card-header">
          <h5>Справочные / спрос
            <button type="button" @click="showUploadToCatalog = !showUploadToCatalog" class="btn btn-default">
              {{ showUploadToCatalog ? 'скрыть' : 'показать' }}
            </button>
          </h5>
        </div>
        <div class="card-body" v-if="showUploadToCatalog">
          <p>Выгружать на справочные с учетом свободных остатков на складе доп. препаратов</p>
          <PairDrugWithKoeff
            ref="pairDrugWithKoeff"
            :savedRecords="details?.related_drug?.upload_to_catalog ?? []"
            :drugId="drug.id"
          />
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="row">
            <template v-if="access.countryCurrency">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="">Страна / Валюта</label>
                  <select class="form-control" v-model="drug.income_country_id" @change="updateCostPrice">
                    <option v-for="country in $AllCountries" :value="country.id">{{ country.name }} /
                      {{ $AllCurrencies[country.currency_id].currency }}
                    </option>
                  </select>
                  <div class="mt-1">
                    <select v-model="newCountry" @change="addNewCountry" class="form-control">
                      <option value="0">Выберите дополнительную страну</option>
                      <option :value="country.id" v-for="country in $AllCountries">{{ country.name }}</option>
                    </select>
                    <div>
                      <div class="input-group" v-for="country in details.extra.country"
                           v-if="!country || !country.to_delete">
                        <input
                          v-model="country.name"
                          disabled
                          class="form-control"
                        />
                        <div class="input-group-append">
                          <button type="button" @click="removeCountry(country)" class="btn btn-outline-danger">
                            <i class="icon-fa icon-fa-trash"/>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="col-md-9">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Страна производства</label>
                    <input class="form-control" type="text" v-model="details.manufacturer.country.value"/>
                  </div>
                </div>
                <template v-if="access.costPrice">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="">Себестоимость</label>
                      <input disabled class="form-control" v-model="drug.cost_price" type="text"/>
                    </div>
                  </div>
                </template>
                <template v-if="access.projectedPrice">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="">Индикативная цена</label>
                      <div class="input-group">
                        <input v-model="drug.projected_price" step="any" type="number" class="form-control">
                        <div class="input-group-append">
                          <input
                            :value="Math.round((+drug.projected_price ?? 0) * ($AllCurrencies[drug.income_currency_id]?.rate ?? 1) * 100)/100"
                            type="text" class="form-control" disabled>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Код PZN
                      <button @click="addPZNCode(null)" type="button" class="btn btn-default btn-xs">Добавить PZN
                      </button>
                    </label>
                    <template v-for="(man, i) in details.grouped.manufacturer">
                      <div class="pzn_code flex" v-if="!man.barcode && (!man.pzn || !man.pzn.to_delete)">
                        <div>
                          <input placeholder="PZN" class="form-control" type="text" v-model="man.pzn.value"/>
                          <input v-if="man.comment" placeholder="Комментарий" class="form-control" type="text"
                                 v-model="man.comment.value"/>
                        </div>
                        <button @click="addPZNCode(i)" type="button" class="btn btn-outline-danger"><i
                          class="icon-fa icon-fa-trash"/></button>
                      </div>
                    </template>
                    <!--                    <input class="form-control" type="text" v-model="details.manufacturer.pzn.value"/>-->
                  </div>

                  <div class="mt-1">
                    <APZNDetail
                      :records="allDetails"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="">Производитель</label>
                <input class="form-control" type="text" v-model="details.manufacturer.title.value"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="">Комплектность</label>
                <input class="form-control" type="number" v-model="drug.pack_set"/>
                <div class="mt-1">
                  <template v-if="!requestData.openOrders">
                    <LoadingButton
                      title="загрузить открытые заявки"
                      className="btn btn-xs btn-outline-success"
                      type="button"
                      :onClick="getOpenOrders"
                      :loading="requestLoading"
                      :color="$constants.SUCCESS_COLOR"
                    />
                  </template>
                  <template v-else>
                    <template v-if="requestData.openOrders.orders && requestData.openOrders.orders.length">
                      <span class="mr-1 badge badge-info" v-for="order in requestData.openOrders.orders">{{
                          order.id
                        }}</span>
                      <div>
                        <a href="#"
                           @click.prevent="mixinGoToRouter('searchOrder', {ordersId: requestData.openOrders.orders.map((o) => o.id)})">
                          показать заявки в поиске
                        </a>
                      </div>
                    </template>
                    <template v-else>
                      <p class="badge badge-dark">Открытых заявок не найдено</p>
                    </template>
                  </template>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="">Тип</label>
                <select disabled class="form-control">
                </select>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <Registration :drug="drug" :detail="details.registration"/>
          </div>
        </div>
      </div>

      <div class="card" v-if="details.suppliers_link_data">
        <div class="card-body">
          <div class="row">
            <div class="col-md-8">
              <div class="form-group">
                <div class="flex flex_gap_10 mb-1">Линки для UTEKA
                  <button @click="addPZNCode(null, 'uteka')" type="button" class="btn btn-default btn-xs">Добавить
                    линк
                  </button>
                  <div class="alert alert-info p-1 m-0">
                    0.5 - ютеки 100р отобр. как 50р; 2 - ютеки 100 р как 200р
                  </div>
                </div>
                <template v-for="(r, i) in details.suppliers_link_data.uteka">
                  <div class="flex no_border_round" v-if="!r.to_delete">
                    <input placeholder="uteka link" class="form-control" type="text" v-model="r.value"/>
                    <input placeholder="Коэфф, 1, 0.5" class="form-control small_input" type="text"
                           v-model="r.decimal_value"/>
                    <input placeholder="Комментарий" class="form-control" type="text" v-model="r.extra_data.comment"/>
                    <button @click="addPZNCode(i, 'uteka')" type="button" class="btn btn-outline-danger"><i
                      class="icon-fa icon-fa-trash"/></button>
                  </div>
                </template>
                <!--                <input type="text" v-model="details.suppliers_link_data.uteka.value" class="form-control">-->
              </div>
              <div class="form-group">
                <label for="">BAR коды
                  <button @click="addPZNCode(null, 'barcode')" type="button" class="btn btn-default btn-xs">Добавить BAR
                    код
                  </button>
                </label>
                <template v-for="(man, i) in details.manufacturer.barcode">
                  <div class="pzn_code flex" v-if="!man || !man.to_delete">
                    <div>
                      <input placeholder="BAR код" class="form-control" type="text" v-model="man.value"/>
                    </div>
                    <button @click="addPZNCode(i, 'barcode')" type="button" class="btn btn-outline-danger"><i
                      class="icon-fa icon-fa-trash"/></button>
                  </div>
                </template>
              </div>
              <div class="form-group">
                <label for="">Линк для EAPTEKA</label>
                <input type="text" v-model="details.suppliers_link_data.eapteka.value" class="form-control">
              </div>
              <div class="form-group">
                <label for="">Линк для APTEKAMOS</label>
                <input type="text" v-model="details.suppliers_link_data.aptekamos.value" class="form-control">
              </div>
            </div>
            <div class="col-md-4">
              <template v-if="access.supplier">
                <div class="form-group">
                  <label for="">Поставщик</label>
                  <select disabled class="form-control">
                  </select>
                </div>
              </template>
              <div class="form-group">
                <label for="">Коэфициент закупки у поставщиков</label>
                <input placeholder="Коэфициент 2,5,10...."
                       :class="{'form-control': true, 'bg_success_back': details.suppliers_data.order_rate.value && details.suppliers_data.order_rate.value !== 0}"
                       type="number"
                       v-model="details.suppliers_data.order_rate.value"/>
              </div>
              <div class="form-group">
                <label for="">Фасовка закупки блистеров</label>
                <input placeholder="Коэфициент 2,5,10...."
                       :class="{'form-control': true, 'bg_success_back': details.suppliers_data.oposit_order_rate.value && details.suppliers_data.oposit_order_rate.value !== 0}"
                       type="number"
                       v-model="details.suppliers_data.oposit_order_rate.value"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Ключевые слова ( разделитель - запятая )</label>
                <textarea class="form-control" v-model='drug.keywords' rows="3"></textarea>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Главный ключевик (разделитель - запятая)</label>
                <textarea class="form-control" v-model='drug.main_keywords' rows="3"></textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="">Комментарии по упаковке (для всех сотрудников)</label>
                <textarea class="form-control" v-model='drug.pack_box_comment' rows="3"></textarea>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="">Информация для проектов, работающих со справочными и ЕГК</label>
                <textarea class="form-control" v-model='details.comment.egkProjects.value' rows="3"></textarea>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="">Комментарий по закупке (для администрации)</label>
                <textarea class="form-control" v-model='drug.purchase_comment' rows="3"></textarea>
              </div>
            </div>
          </div>
          <div class="mb-2">
            <div class="form-group">
              <label for="">Комментарий по выкладке на складах (для кладовщиков)</label>
              <!--              <textarea class="form-control" v-model='drug.pack_comment' rows="3"></textarea>-->
              <DrugCommentsBlock :detail="details.stores_info.comments" ref="drugsStoresComments"/>
            </div>
          </div>
          <div>
            <label for="">Информация (временная) для менеджеров (сроки годности, скидка, возможность замены и
              т.п.)</label>
            <DrugCommentsBlock :detail="details.managers_info.comments" ref="drugsManagersComments"/>
          </div>
          <template v-if="access.priority">
            <Priority :drug="drug"/>
          </template>
          <div class="text-right">
            <LoadingButton
              :title="drug.id ? 'Сохранить' : 'Создать препарат'"
              className="btn btn-success"
              type="submit"
              :onClick="() => {}"
              :loading="btnLoading"
              color="white"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton";
import Priority from './details/Priority'
import Recipe from './details/Recipe'
import Registration from './details/Registration'
import DrugSearchNew from "@/components/drugs/DrugSearchNew";
import EgkSelect from "@/views/nomenclature/components/details/EgkSelect";
import TasksProjectCreate from "@/views/nomenclature/components/details/TasksProjectCreate";
import SelectCombineDrugs from "@/views/nomenclature/components/SelectCombineDrugs.vue";
import PairDrugWithKoeff from "@/components/drugs/PairDrugWithKoeff.vue";
import DrugCommentsBlock from "@/views/nomenclature/components/DrugCommentsBlock.vue";
import TitleForSuppliers from "@/views/nomenclature/components/details/TitleForSuppliers.vue";
import APZNDetail from "@/views/nomenclature/components/details/APZNDetail.vue";
import CountrySupplierData from "@/views/nomenclature/components/details/CountrySupplierData.vue";
import CountryDimension from "@/views/stores/components/CountryDimension.vue";

export default {
  components: {
    CountryDimension,
    CountrySupplierData,
    APZNDetail,
    TitleForSuppliers,
    DrugCommentsBlock,
    PairDrugWithKoeff,
    SelectCombineDrugs,
    LoadingButton,
    Priority,
    Recipe,
    Registration,
    DrugSearchNew,
    EgkSelect,
    TasksProjectCreate,
  },
  props: ['selectedDrug', 'closeModal', 'data'],
  data() {
    return {
      newDimension: {countryId: 0},
      showUploadToCatalog: false,
      editDrugDimensions: false,
      access: {
        priority: true,
        countryCurrency: false,
        supplier: false,
        costPrice: false,
        projectedPrice: false,
        projectPrices: false,
      },
      supplierData: {
        link: null
      },
      defaultSupplierData: {
        uteka: {value: null},
        eapteka: {value: null},
        aptekamos: {value: null},
      },
      allDetails: [],
      drug: null,
      newCountry: 0,
      loading: false,
      details: null,
      btnLoading: false,
      requestLoading: false,
      requestData: {
        openOrders: null
      },
      defaultDetails: {
        comment: [
          {value: null, type: 'text', group_alias: 'comment', alias: 'egkProjects'}
        ]
      },
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
    $AllCountries() {
      return this.$store.getters['platform/countries']
    },
  },
  watch: {
    selectedDrug() {
      if (this.selectedDrug && this.selectedDrug.id) {
        this.getDrug();
      }
    },
  },
  async mounted() {
    this.initNewDrug();
    if (this.selectedDrug) {
      await this.getDrug();
    }
    if (this.$currentRole === 'admin') {
      this.access = Object.keys(this.access).reduce((acc, a) => {
        acc[a] = true;
        return acc;
      }, {})
    }
    if (this.$currentUserRoles.includes('merchandiser')) {
      this.access.projectPrices = true;
      this.access.countryCurrency = true;
    }
    this.showUploadToCatalog = !!(this.details?.related_drug?.upload_to_catalog ?? []).length;
  },
  methods: {
    async getDimensionTask(id) {
      this.btnLoading = true;
      const {data} = await api.post('/new/drugs/details/update', {
        drug_id: id,
        action: 'addNew',
        detail_type: 'country_dimension',
        detail_data: this.newDimension
      })
      if (data.success) {
        toastr['success']('Задача успешно создана');
      } else {
        toastr['error'](data.message || 'Ошибка создания задачи');
      }
      this.btnLoading = false;
    },
    removeCountry(record) {
      const index = this.details.extra.country.findIndex((c) => c.id === record.id);
      if (index !== -1) {
        this.details.extra.country[index].to_delete = true;
        this.details = {...this.details};
      }
    },
    addNewCountry(e) {
      if (this.newCountry) {
        if (!this.details.extra.country) this.details.extra.country = [];
        const selected = this.details.extra.country.find((d) => +d.value === +this.newCountry);
        if (selected || +this.newCountry === this.drug.income_country_id) {
          toastr['warning']('Страна уже используется для этого препарата');
          this.newCountry = 0;
          return;
        }
        const country = this.$AllCountries.find((c) => c.id === +this.newCountry);
        this.details.extra.country.push({
          alias: "country",
          group_alias: 'extra',
          type: "int",
          to_delete: false,
          value: country.id,
          name: country.name
        });
      }
      this.newCountry = 0;
    },
    async getOpenOrders() {
      this.requestLoading = true;
      const {data} = await api.post('new/orders/getOrdersByFilter', {
        type: 'openOrders',
        drug_id: this.selectedDrug.id
      })
      if (data.success) {
        this.requestData.openOrders = {orders: data.records};
      } else {
        toastr['error'](data.error || 'Ошибка получения данных!');
      }
      this.requestLoading = false;
    },
    initNewDrug() {
      this.loading = true;
      this.drug = {
        title: null,
        en_title: null,
        income_currency_id: 28,
        income_country_id: 1,
        substance: null,
        pack_set: 1,
        packaging: null,
        cool: false,
        lgot_price: false,
        keywords: null,
        keyword: null,
      };
      this.details = {
        extra: {},
        egk: {},
        supplier: [],
        managers_info: {
          comments: {alias: 'comments', group_alias: 'managers_info', type: 'array', value: []}
        },
        stores_info: {
          comments: {alias: 'comments', group_alias: 'stores_info', type: 'array', value: []}
        },
        grouped: {
          manufacturer: [{
            pzn: {value: null, type: 'text', to_delete: false},
            comment: {value: null, type: 'text', to_delete: false},
          }],
        },
        recipe: {
          no_use: {value: false, type: 'int', group_alias: 'recipe', alias: 'no_use'},
          lt_title: {value: null, type: 'text', group_alias: 'recipe', alias: 'lt_title'},
          signa: {value: null, type: 'text', group_alias: 'recipe', alias: 'signa'},
          pack: {value: null, type: 'int', group_alias: 'recipe', alias: 'pack'},
          days: {value: null, type: 'int', group_alias: 'recipe', alias: 'days'}
        },
        manufacturer: {
          title: {value: null, type: 'text'},
          country: {value: null, type: 'text'},
          barcode: [],
          // barcode: {value: null, type: 'text'},
          // pzn: {value: null, type: 'text'}
        },
        country_data: {},
        suppliers_link_data: {
          uteka: []
        },
        regular_reception: {
          use: {value: false, type: 'int'},
          days: {value: null, type: 'int'},
        },
        suppliers_data: {
          order_rate: {value: null, type: 'int', group_alias: 'suppliers_data', alias: 'order_rate'},
          oposit_order_rate: {value: null, type: 'int', group_alias: 'suppliers_data', alias: 'oposit_order_rate'},
        },
        registration: {
          use: {value: null, type: 'int'},
          type: {value: 0, type: 'int'},
          date: {value: null, type: 'text'},
        }
      };
      this.loading = false;
    },
    async getDrug() {
      this.loading = true;
      this.drug = null;
      this.initNewDrug();
      const {data} = await api.index('/new/drugs/edit/' + this.selectedDrug.id)
      if (data.success) {
        this.drug = data.drug;
        if (data.supplierData && data.supplierData.id) {
          this.supplierData = data.supplierData;
        }
        if (Array.isArray(this.drug.keywords)) {
          this.drug.keywords = (this.drug.keywords || []).join(', ');
        }
        if (Array.isArray(this.drug.main_keywords)) {
          this.drug.main_keywords = (this.drug.main_keywords || []).join(', ');
        }
        this.drug.pack_set = Math.round(data.drug.pack_set);
        this.allDetails = data.details.map((d) => {
          d.to_delete = false;
          return d;
        });
        const details = data.details.reduce((acc, d) => {
            if (d.group_alias === 'manufacturer' && ['pzn', 'comment'].includes(d.alias)) {
              return acc;
            }
            const detail = {
              ...d,
              id: d.id,
              alias: d.alias,
              group_alias: d.group_alias,
              type: d.type,
              value: d[d.type + '_value'],
              decimal_value: d.decimal_value,
              extra_data: d.extra_data ?? {},
              array_value: d.array_value ?? {},
              to_delete: false,
            };

            delete detail.text_value;
            // if (d.group_alias === 'country_data') {
            //   if (!acc.country_data) acc.country_data = {};
            //   if (!acc.country_data[detail.int_value]) acc.country_data[detail.int_value] = {};
            //   acc.country_data[detail.int_value][detail.alias] = detail;
            //   acc.country_data[detail.int_value].to_delete = false;
            //   acc.country_data[detail.int_value].country_id = detail.int_value;
            //   return acc;
            // }

            if ((d.group_alias === 'manufacturer' && d.alias === 'barcode')
              || (d.group_alias === 'suppliers_link_data' && d.alias === 'uteka')
              || (d.group_alias === 'related_drug' && d.alias === 'upload_to_catalog')
            ) {
              if (!acc[d.group_alias]) acc[d.group_alias] = {};
              if (!acc[d.group_alias][d.alias]) acc[d.group_alias][d.alias] = [];
              acc[d.group_alias][d.alias].push(detail);
              return acc;
            }
            if (!acc[d.group_alias]) acc[d.group_alias] = {}
            if (d.group_alias === 'extra') {
              if (!acc[d.group_alias][d.alias]) acc[d.group_alias][d.alias] = [];
              if (d.alias === 'country') {
                const country = this.$AllCountries.find((c) => c.id === d.int_value);
                acc[d.group_alias][d.alias].push({
                  ...d,
                  name: country.name,
                  value: d.int_value,
                  to_delete: false
                });
                return acc;
              }
            }
            if (['egk'].includes(d.group_alias)) {
              if (!acc[d.group_alias][d.group_parent_id]) acc[d.group_alias][d.group_parent_id] = {}
              acc[d.group_alias][d.group_parent_id][d.alias] = detail;
              if (d.alias === 'id') {
                const code = data.egkCodes.find((c) => c.id === d.int_value);
                if (code) {
                  acc[d.group_alias][d.group_parent_id].invalid = code.invalid;
                }
              }
            } else {
              acc[d.group_alias][d.alias] = detail;
            }
            return acc;
          },
          {...this.details}
        )
        Object.keys(this.details).forEach((groupAlias) => {
          if (!details[groupAlias]) {
            details[groupAlias] = {...this.details[groupAlias]}
          }
        })

        const gropedDetails = data.details.filter((d) => d.group_alias === 'manufacturer' && ['pzn', 'comment',].includes(d.alias)).reduce((acc, d) => {
          if (!d.group_parent_id && d.alias === 'pzn') {
            d.group_parent_id = 0;
          }
          if (!acc[d.group_parent_id]) acc[d.group_parent_id] = {};
          acc[d.group_parent_id][d.alias] = {...d, value: d[d.type + '_value'], to_delete: false}
          acc[d.group_parent_id][d.alias][d.type + '_value'] = null;
          return acc;
        }, {})
        details.grouped.manufacturer = Object.values(gropedDetails);

        // data.details.filter((d) => d.group_alias === 'manufacturer' && d.alias === 'barcode').forEach((d) => {
        //   details.grouped.manufacturer.push({barcode: {...d, value: d[d.type + '_value'], to_delete: false}})
        // })

        // if (!details.manufacturer.barcode) details.manufacturer.barcode = {value: null};
        // if (!details.manufacturer.pzn) details.manufacturer.pzn = {value: null};
        Object.keys(this.defaultSupplierData).forEach((k) => {
          if (!details.suppliers_link_data) details.suppliers_link_data = {};
          if (!details.suppliers_link_data[k]) details.suppliers_link_data[k] = this.defaultSupplierData[k];
        })

        Object.keys(this.defaultDetails).forEach((d) => {
          this.defaultDetails[d].forEach((a) => {
            if (!details[d]) details[d] = {};
            if (!details[d][a.alias]) details[d][a.alias] = {...a};
          })
        })

        this.details = {...details};
      } else {
        toastr['error'](data.error || 'Ошибка получения данных!');
      }
      this.loading = false;
    },
    addPZNCode(deleteIndex = null, alias = 'pzn') {
      switch (alias) {
        case 'pzn':
          if (deleteIndex !== null) {
            this.details.grouped.manufacturer[deleteIndex].pzn.to_delete = true;
            if (this.details.grouped.manufacturer[deleteIndex].comment) this.details.grouped.manufacturer[deleteIndex].comment.to_delete = true;
            return;
          }
          this.details.grouped.manufacturer.push({
            pzn: {value: null, type: 'text', to_delete: false},
            comment: {value: null, type: 'text', to_delete: false},
          });
          break;
        case 'barcode':
        case 'uteka':
          let groupIndex = 'manufacturer';
          if (alias === 'uteka') groupIndex = 'suppliers_link_data';
          if (deleteIndex !== null) {
            this.details[groupIndex][alias][deleteIndex].to_delete = true;
            this.details[groupIndex] = {...this.details[groupIndex]};
            return;
          }
          const rec = {
            alias: alias, group_alias: groupIndex, value: null, type: 'text', to_delete: false
          };
          if (alias === 'uteka') rec.extra_data = {comment: null};
          this.details[groupIndex][alias].push(rec);
          break;
      }
    },
    validateDrug() {
      let error = [];
      if (!this.drug.priority) {
        error.push('Не указан приоритет')
      }
      // if (!this.prices[0].price || this.prices[0].price <= 0) {
      //   error.push('Не валидная цена на количество 1');
      // }
      // if (!this.category) {
      //   error.push('Не указана категория');
      // }
      if (!this.drug.pack_set || this.drug.pack_set <= 0) {
        error.push('Не верно указана комплектность');
      }
      if (!this.details.recipe.no_use.value) {
        if (!this.details.recipe.lt_title.value
          || !this.details.recipe.signa.value
          || !this.details.recipe.days.value
          || this.details.recipe.days.value < 0
          || !this.details.recipe.pack.value
          || this.details.recipe.pack.value < 0
        ) {
          error.push('Неверные данные для рецепта');
        }
      }
      return error;
    },
    async saveDrug() {
      const noValid = this.validateDrug();
      if (noValid.length) {
        toastr['warning'](noValid.join("\n"));
        return;
      }

      let pairDrugWithRate = this.$refs.pairDrugWithKoeff?.validate();
      if (this.$refs.pairDrugWithKoeff && !pairDrugWithRate?.success) {
        toastr['warning'](pairDrugWithRate?.message ?? 'ошибка в блоке препаратов для справочной');
        return;
      }
      if (!this.$refs.pairDrugWithKoeff) {
        pairDrugWithRate = {records: []};
      }

      this.btnLoading = true;

      this.details.managers_info.comments.value = [];
      this.details.managers_info.comments.array_value = this.$refs.drugsManagersComments.getRecords();
      this.details.managers_info.comments.date_value = this.$refs.drugsManagersComments.getOldestDate();

      this.details.stores_info.comments.value = [];
      this.details.stores_info.comments.array_value = this.$refs.drugsStoresComments.getRecords();
      this.details.stores_info.comments.date_value = this.$refs.drugsStoresComments.getOldestDate();

      // console.log(this.$refs.drugsManagersComments.getRecords());
      // console.log(this.$refs.drugsManagersComments.getOldestDate());
      // console.log(this.$refs.drugsStoresComments.getRecords());
      // console.log(this.$refs.drugsStoresComments.getOldestDate());

      const allDetails = {...this.details};
      delete allDetails.extra;
      delete allDetails.egk;
      // console.log(allDetails);

      let details = Object.values(allDetails).reduce((acc, d) => {
        if (!['egk', 'extra'].includes(d.group_alias)) {
          Object.values(d).forEach((o) => acc.push(o))
        }
        if (d.barcode) {
          acc = [...acc, ...d.barcode];
        }
        if (d.uteka) {
          acc = [...acc, ...d.uteka];
        }
        return acc;
      }, []);

      Object.keys(allDetails).forEach((group) => {
        if (!['regular_reception'].includes(group)) return;
        Object.keys(allDetails[group]).forEach((alias) => {
          details.push({
            ...allDetails[group][alias],
            group_alias: group,
            alias
          })
        })
      });

      Object.keys(this.details.country_data).forEach((cId) => {
        Object.keys(this.details.country_data[cId]).forEach((alias) => {
          if (alias === 'to_delete' || alias === 'country_id' || !+this.details.country_data[cId].country_id) return;
          details.push({
            ...this.details.country_data[cId][alias],
            group_alias: 'country_data',
            alias,
            to_delete: this.details.country_data[cId].to_delete
          })
        })
      })

      // console.log(details);
      // console.log(this.$refs.countryDimensions.getDetails());
      details = [...details,
        ...this.allDetails.filter((d) => ['manufacturer'].includes(d.group_alias) && ['apzn'].includes(d.alias)),
        ...this.allDetails.filter((d) => ['supplier_data'].includes(d.group_alias)),
        ...this.allDetails.filter((d) => d.group_alias === 'country_data' && d.alias !== 'dimensions'),
        ...this.$refs.countryDimensions.getDetails(),
        // ...this.allDetails.filter((d) => d.group_alias === 'country_data' && d.alias === 'dimensions' && d.int_value && Object.values(d.array_value ?? {}).find((v) => v)),
      ];

      // console.log(details);

      delete this.details.suppliers_link_data.uteka;
      await this.$refs.egkCodes.updateAllCodes();

      pairDrugWithRate.records.forEach((d) => details.push(d));

      const {data} = await api.post('/new/drugs/updatedrug', {
        drug: {...this.drug, combined_type: +this.$refs.combineDrugs.combineType},
        details,
        combineDrugs: this.$refs.combineDrugs.combinedList,
        supplierData: this.supplierData,
        suppliersLinkData: this.details.suppliers_link_data,
        grouped: {
          manufacturer: this.details.grouped.manufacturer,
          egk: this.$refs.egkCodes.details,
          // managersComments: this.$refs.drugsManagersComments.getRecords(),
          extra: (this.details.extra.country || []).reduce((acc, c) => {
            const obj = {};
            obj[c.alias] = c;
            acc.push(obj)
            return acc;
          }, []) || []
        }
      })
      if (data.success) {
        toastr['success'](data.message || 'Сохранено!');
        await this.getDrug();
        if (this.data) {
          this.data.updated = true;
        }
      } else {
        toastr['error'](data.message || 'Ошибка сохранения!');
      }
      this.btnLoading = false;
    },
    updateCostPrice() {
      // this.costPrice = 0;
      const country = this.$AllCountries.find((c) => c.id === +this.drug.income_country_id);
      this.drug.income_currency_id = country.currency_id;
      // if (this.buePrice) {
      //   this.costPrice = Math.round(+this.buePrice * this.$AllCurrencies[this.drug.income_currency_id].rate * 100) / 100;
      // }
    }
  }

}

</script>

<style scoped>
textarea {
  font-size: 13px;
}

.small_input {
  width: 65px;
}

.no_border_round input,
.no_border_round button {
  border-radius: 0;
}

.card {
  margin-bottom: 5px;
}
</style>
